export default "__VITE_ASSET__DID9r5M9__"